import {useMutation, useSuspenseQuery} from '@tanstack/react-query';
import type {TwoFactorCode} from "_types/requests/two-factor";

import {apiSwr, routes} from '_api';
import {AuthService} from "_services/auth.service";
import {disableTwoFactor, enableTwoFactor, getTwoFactor, validateTwoFactor} from "_api/fetchers/two-factor";

export function useTwoFactor() {
    const queryKey = [...routes.twoFactor.token] as const;

    const swr = useSuspenseQuery({
        queryKey,
        queryFn: getTwoFactor,
    });
    const twoFactor = swr.data;

    return {...swr, twoFactor} as const;
}


export function useEnableTwoFactor() {
    const mutationKey = [...routes.twoFactor.confirm] as const;

    return useMutation({
        mutationKey,
        mutationFn: async (payload: TwoFactorCode) => {
            return enableTwoFactor(mutationKey, payload);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {
            await apiSwr.invalidateQueries({queryKey: [...routes.auth.currentUser]});
            await apiSwr.invalidateQueries({queryKey: [...routes.twoFactor.token]})
        },
        onError: err => {

        },
    });
}

export function useDisableTwoFacto() {
    const mutationKey = [...routes.twoFactor.disable] as const;

    return useMutation({
        mutationKey,
        mutationFn: async () => {
            return disableTwoFactor(mutationKey);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {
            await apiSwr.invalidateQueries({queryKey: [...routes.auth.currentUser]});
            await apiSwr.invalidateQueries({queryKey: [...routes.twoFactor.token]})
        },
        onError: err => {

        },
    });
}

export function useValidateTwoFactor() {
    const mutationKey = [...routes.twoFactor.validate] as const;

    return useMutation({
        mutationKey,
        mutationFn: async (payload: TwoFactorCode) => {
            return validateTwoFactor(mutationKey, payload);
        },

        onMutate: async d => {

        },
        onSuccess: async d => {
            if (d?.token) {
                await apiSwr.invalidateQueries({queryKey: [...routes.auth.currentUser]});
                AuthService.setToken(d.token, false);
            }
        },
        onError: err => {
        },
    });
}
